export interface ProjectInput {
  name: string;
  industry?: string;
  form?: Record<string, unknown>;
}

export interface SubmissionIntent {
  projectRequestId: string;
  jobRequestId: string;
  input: ProjectInput;
  projectId?: string;
  jobId?: string;
}

export function newSubmission(input: ProjectInput): SubmissionIntent {
  return { projectRequestId: crypto.randomUUID(), jobRequestId: crypto.randomUUID(), input };
}

/** Persist each acknowledged ID; ambiguous failures reuse the original UUIDs. */
export async function submitProject(
  intent: SubmissionIntent,
  api: {
    createProject(input: ProjectInput, requestId: string): Promise<{ id: string }>;
    startJob(projectId: string, requestId: string): Promise<{ job_id: string }>;
  },
  save: (intent: SubmissionIntent) => void,
  phase: (message: string) => void,
  hooks?: { beforeStartJob?: (projectId: string) => Promise<void> },
): Promise<string> {
  if (intent.jobId) return intent.jobId;
  if (!intent.projectId) {
    phase("正在保存品牌资料…");
    const result = await api.createProject(intent.input, intent.projectRequestId);
    if (!result.id) throw new Error("保存项目响应异常，请继续本次提交。");
    intent = { ...intent, projectId: result.id };
    save(intent);
  }
  if (hooks?.beforeStartJob) {
    phase("正在上传文档资料…");
    await hooks.beforeStartJob(intent.projectId!);
  }
  phase("资料已保存，正在启动生成…");
  const result = await api.startJob(intent.projectId!, intent.jobRequestId);
  if (!result.job_id) throw new Error("启动任务响应异常，请继续本次提交。");
  save({ ...intent, jobId: result.job_id });
  return result.job_id;
}
